import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {IGetSeoRequest, IGetSeoResponse} from 'modules/seo/types';

export const seoApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getSeo: builder.query<IGetSeoResponse['data'], IGetSeoRequest>({
            query: (payload: IGetSeoRequest) => {
                return {
                    url: `${API_VERSION}/seo`,
                    body: payload,
                    method: 'POST',
                };
            },
            transformResponse: (response: IGetSeoResponse): IGetSeoResponse['data'] => ({
                ...response.data,
            }),
            serializeQueryArgs: ({endpointName, queryArgs}) => {
                const {type, filter, redirectType} = queryArgs as IGetSeoRequest;
                const filterKey = filter?.url || filter?.code || filter?.id || '';
                return `${endpointName}_${type}_${filterKey}_${redirectType || ''}`;
            },
            keepUnusedDataFor: 300,
        }),
    }),
});

export const {useGetSeoQuery, useLazyGetSeoQuery} = seoApiService;

export const {getSeo} = seoApiService.endpoints;
